import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X } from "lucide-react";
import { api } from "../../context/AuthContext";

export const PriceEditor = ({ productId, price, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(String(price));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) {
      toast.error("Enter a valid price");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.patch(`/admin/catalog/${productId}/price`, { price: n });
      onSaved(data.price);
      setEditing(false);
      toast.success(`Price updated to $${data.price} CAD`);
    } catch {
      toast.error("Could not update price");
    } finally {
      setSaving(false);
    }
  };

  if (!editing) {
    return (
      <button
        type="button"
        data-testid={`price-edit-${productId}`}
        onClick={() => {
          setValue(String(price));
          setEditing(true);
        }}
        className="inline-flex items-center gap-1.5 font-mono text-xs text-oxblood ml-2 hover:underline underline-offset-4"
        title="Edit price"
      >
        <span data-testid={`price-value-${productId}`}>${price} CAD</span>
        <Pencil className="w-3 h-3" />
      </button>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 ml-2">
      <span className="font-mono text-xs text-mutedink">$</span>
      <input
        type="number"
        min="0"
        step="0.01"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") save();
          if (e.key === "Escape") setEditing(false);
        }}
        data-testid={`price-input-${productId}`}
        className="w-24 border border-ink/20 bg-white px-2 py-1 font-mono text-xs text-ink focus:outline-none focus:border-oxblood"
        autoFocus
      />
      <span className="font-mono text-xs text-mutedink">CAD</span>
      <button
        type="button"
        data-testid={`price-save-${productId}`}
        onClick={save}
        disabled={saving}
        className="p-1 text-ink hover:text-oxblood disabled:opacity-40"
        aria-label="Save price"
      >
        <Check className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        data-testid={`price-cancel-${productId}`}
        onClick={() => setEditing(false)}
        className="p-1 text-mutedink hover:text-oxblood"
        aria-label="Cancel"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </span>
  );
};
